(function($, d, g) {
	
	'use strict';
	
	
	function init() {
        $("#visibilitySwitch").on("change", getSelectedCheckboxLists);
    }

    function getSelectedCheckboxLists() {
        const isChecked = this.checked;
        
        $.ajax({
            url: "/action/changeVisibility",
            method: "POST",
            cache: false,
            data: {
                status: isChecked,
            },
            success: function(response) {
                // Reload page
                window.location.reload();
            },
            error: function(response) {
                // Handle error
                console.error("Error changing visibility:", response);
            }
        });
    }
	
    $(g).ready(init);

})(jQuery, document, window);